import { initFancybox } from "@solvari/components";

import "./videoPlayer.css";

initFancybox();
